// Constantes específicas para la reprogramación de servicios
export const SERVICE_RESCHEDULE_ENDPOINTS = {
  BASE_PATH: '/api/customer-care/v1',
  AVAILABLE_SCHEDULES: '/reschedule/date',
  RESCHEDULE_SERVICE: '/api/service'
} as const;

// Configuración de UI
export const SERVICE_RESCHEDULE_UI_CONFIG = {
  DEFAULT_VISIBLE_SCHEDULE_COUNT: 5
};

export const SERVICE_TIME_RANGES = [
  { value: 'MORNING', label: 'Turno mañana' },
  { value: 'AFTERNOON', label: 'Turno tarde' },
] as const;

export const DEFAULT_TIME_RANGE = 'MORNING';

export const SERVICE_RESCHEDULE_TIMEOUTS = {
  DEFAULT: 10000, // 10 segundos
  LONG_OPERATION: 30000 // 30 segundos
} as const;

export const SERVICE_RESCHEDULE_CHANNELS = {
  HORUS: 'HORUS',
  GENESYS: 'GENESYS',
  CALL_CENTER: 'CALL_CENTER'
} as const;

export const SERVICE_RESCHEDULE_ERROR_CODES = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  SERVICE_ERROR: 'SERVICE_ERROR',
  NETWORK_ERROR: 'NETWORK_ERROR',
  LOAD_SCHEDULES_ERROR: 'LOAD_SCHEDULES_ERROR',
  TIMEOUT_ERROR: 'TIMEOUT_ERROR'
} as const;

export const SERVICE_RESCHEDULE_REASONS = {
  CUSTOMER_REQUEST: 'CUSTOMER_REQUEST',
  TECHNICAL_ISSUE: 'TECHNICAL_ISSUE',
  WEATHER_CONDITIONS: 'WEATHER_CONDITIONS',
  AVAILABILITY_CONFLICT: 'AVAILABILITY_CONFLICT'
} as const;

export const SERVICE_RESCHEDULE_MESSAGES = {
  VALIDATION_ERROR: 'Datos incompletos para reprogramación',
  SERVICE_ERROR: 'Error al reprogramar el servicio',
  NETWORK_ERROR: 'No se pudo reprogramar el servicio. Intenta nuevamente.',
  LOAD_SCHEDULES_ERROR: 'No se pudieron cargar los horarios disponibles.',
  TIMEOUT_ERROR: 'La operación tardó demasiado tiempo. Intenta nuevamente.',
  SUCCESS: 'Servicio reprogramado exitosamente'
} as const;

// Tipos para mayor type safety
export type ServiceRescheduleReason = typeof SERVICE_RESCHEDULE_REASONS[keyof typeof SERVICE_RESCHEDULE_REASONS];
export type ServiceRescheduleErrorCode = typeof SERVICE_RESCHEDULE_ERROR_CODES[keyof typeof SERVICE_RESCHEDULE_ERROR_CODES];

export const serviceRescheduleMeta = {
  channel: 'HORUS',
  turn: 'AFTERNOON',
  motiveId: 35,
  observations: 'Reprogramado desde Horus',
  type: '35',
} as const;
